import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=72c9c2cc&"
import script from "./TermsModal.vue?vue&type=script&lang=js&"
export * from "./TermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c9c2cc')) {
      api.createRecord('72c9c2cc', component.options)
    } else {
      api.reload('72c9c2cc', component.options)
    }
    module.hot.accept("./TermsModal.vue?vue&type=template&id=72c9c2cc&", function () {
      api.rerender('72c9c2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/fuel-funds/TermsModal.vue"
export default component.exports